import { useState } from "react";
import { Modal } from "react-bootstrap";
import AlertBox from "../../AlertBox";
import { deleteFramedPoolById } from "../../../api/infrastructure";
import { useFramedPoolByIdHooks } from "../../../utils/infrastructure/FramedPoolUtils";
import { LoadingInsideBox, LoadingInsideBoxWrapper } from "../../Loading";

export default function ModalDeleteFramedPool({ id, show, onClose, onSuccess }) {
  return (
    <Modal show={show} onHide={() => onClose()}>
      <FormDeleteFramedPool id={id} onSuccess={onSuccess} onClose={() => onClose()} />
    </Modal>
  );
}

function FormDeleteFramedPool({ id, onSuccess, onClose }) {
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });
  const { data, error, loading: loadingData } = useFramedPoolByIdHooks({ id });

  const handleClose = () => {
    if (!loading) {
      setAlert({ show: false, message: "", type: "" });
      onClose();
    }
  };

  const deleteFramedPool = async () => {
    setLoading(true);
    try {
      const { data } = await deleteFramedPoolById(id);
      onSuccess(data.message);
      handleClose();
    } catch (error) {
      let message = error.response?.data?.message || "Something Error Happened";
      setAlert({ show: true, message, type: "danger" });
    }
    setLoading(false);
  };

  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title>Hapus Framed Pool</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <LoadingInsideBoxWrapper>
          {(loading || loadingData) && <LoadingInsideBox />}
          {error && <div className="alert alert-danger">{error}</div>}
          <AlertBox {...alert} setAlert={setAlert} />
          <h5 className="text-gray-800">
            Apakah anda yakin untuk menghapus framed pool "{data.name}"?
          </h5>
        </LoadingInsideBoxWrapper>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={handleClose}>
          Close
        </button>
        <button disabled={loading} className="btn btn-danger" onClick={deleteFramedPool}>
          {loading ? "Deleting..." : "Delete Framed Pool"}
        </button>
      </Modal.Footer>
    </>
  );
}
